import { render, staticRenderFns } from "./_disposalSubscriberForm.vue?vue&type=template&id=b19ae22e&"
import script from "./_disposalSubscriberForm.vue?vue&type=script&lang=js&"
export * from "./_disposalSubscriberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports